<template>
  <div>
    <div class="logout" v-if="userID">
      <a href="#/participate" @click="logout">Log out</a>
    </div>

    <div :class="'artist-new' + (userID ? ' logged-in' : '')">
      <header>
        <h1>Austin Studio Tour</h1>
      </header>

      <section class="card" v-if="step === 'loading'">
        <h2>Please wait...</h2>
        <p>Loading your existing application.</p>
        <p>Not you? <a href="#" @click="logout">Log out</a></p>
      </section>

      <section class="card" v-if="step === 'login'">
        <h2 v-if="!createAccount">Log in</h2>
        <h2 v-else>Create an Account</h2>
        <p v-if="createAccount">Create an account so you can pick up where you leave off.</p>
        <p v-if="createAccount">Already started? <a href="#" @click="createAccount = false">Log in</a></p>

        <div v-on:keyup.enter="login">
          <div class="field">
            <div class="input">
              <label class="input-label">Username</label>
              <input type="text" autocomplete="none" v-model="username" class="input-field">
            </div>
          </div>
          <div class="field">
            <div class="input">
              <label class="input-label">Password</label>
              <input type="password" autocomplete="current-password" v-model="password" class="input-field">
            </div>
            <p v-if="!createAccount">Forgot password? <a href="mailto:info@bigmedium.org?subject=Forgot Password" target="_blank">Email us</a>.</p>
          </div>

          <div class="submit single">
            <button :class="'btn' + (loading ? ' loading' : '')" @click="login" :disabled="loading">Log in</button>
          </div>
        </div>
      </section>

      <section class="card" v-if="step === 0">
        <h2>Overview</h2>
        <p>The Austin Studio Tour will take place over 2 weekends in November and will be divided into two regions, WEST of IH35 and EAST of IH35. This will allow audiences to choose between weekends and regions and plan accordingly. Also, artists from each region can support, visit, and enjoy the tour on their free weekend!</p>
        <br />
        <ul>
          <li><strong>Weekend 1:</strong> November 9-10 WEST of IH-35</li>
          <li><strong>Weekend 2:</strong> November 16-17 EAST of IH-35</li>
          <li>If applicable. Programs can occur any day between November 9-17 </li>
        </ul>
        <p>The Austin Studio Tour produced by Big Medium, is a free, self-guided art event that combines the West Austin Studio Tour and East Austin Studio Tour to provide opportunities for artists all over Austin to connect with each other, showcase current work, and for the public to experience the cultural vibrancy of our city.</p>
        <br />
        <p><strong>Open call:</strong> July 1, 2:00 pm - July 31, 11:59 pm</p>
        <br/>
        <p><strong>Tour dates:</strong> November 9-10 and 16-17, 2024</p>
        <br/>
        <p><strong>Tour hours:</strong> 12 - 6 pm</p>
        <br/>
        <p><strong>Boundaries:</strong> Within the 10 City Council districts of Austin, plus a 10-mile radius from the Capitol. Some restrictions may apply.</p>
        <br/>
        <div class="field other">
          <label class="input-label">Do you have a space within the boundaries? (Within the 10 City Council districts of Austin, plus a 10-mile radius from the Capitol.)<span class="required">*</span></label>
          <br />
          <br />
          <p>To apply, you have to have a space secured before completing your application, the space should be available both weekends for the weekend of the studio tour depending on the side of IH35 you’re located. Please also consider that once the application process has been closed no changes are allowed. Big Medium is a Nonprofit that’s unable to provide spaces, but we encourage you to contact friends, family and your local businesses to share available spaces.</p>
          <br />
          <div class="input-radio">
            <label>
              <input type="checkbox" value="yes" name="required-space" v-model="submission.space_acknowledgement">
              <span for="yes">Yes, I have access to a space within the above boundaries</span>
            </label>
          </div>
        </div>
        <br />
        <div class="field other">
          <label class="input-label">Are you able to commit to opening doors to the TWO days (listed above) of your side of the tour from 12-6pm?<span class="required">*</span>
          </label>
          <br />
          <br />
          <p>Both days are required to participate officially in the tour, open hours are the same for everyone participating, 12-6pm, no exceptions are allowed.</p>
          <br />
          <div class="input-radio">
            <label>
              <input type="checkbox" value="yes" name="required-time-commitment" v-model="submission.time_acknowledgement">
              <span for="yes">Yes, I am able to commit to the TWO days in the given time frames</span>
            </label>
          </div>
        </div>

        <div class="submit single">
          <button :class="'btn' + (loading ? ' loading' : '')" @click="nextStep" :disabled="!step0Valid">Continue</button>
        </div>
      </section>

      <section class="card" v-if="step === 1">
        <div class="field other" v-if="schema">
          <label class="input-label">How are you participating?<span class="required">*</span></label>
          <div class="input-radio">
            <label v-for="option in schema.type.enum" :key="option">
              <input type="radio" :value="option" v-model="submission.type">
              <span>{{ option }}</span>
            </label>
          </div>
        </div>

        <p><strong>Artists:</strong> Solo artists, collaboratives, and collectives. Only one set of information will be listed online (name, social media, website), and one image in the catalog. Six images will be included on the website and in the app.</p>
        <br />
        <br />
        <p><strong>Dedicated Art Spaces:</strong> Dedicated Art Spaces: Spaces include those that hold art programming throughout the year such as galleries, museums, and cultural centers. In this case, the venue’s information and name of the exhibit or artists participating in the Austin Studio Tour will be listed. If featuring multiple artists, Dedicated Art Spaces should consider additionally featuring each individual artist.</p>
        <br />
        <br />
        <p><strong>Temporary Art Experience:</strong> Groups and organizations coordinating an exhibition or art programming in a temporary space. This can include group exhibitions, markets, pop-up installations, performances, etc. featured in non-arts venues. <br /> <br />E.g. Future Front hosting a market or event in a different venue would be listed as a temporary art experience since their space and programming shifts throughout the year, but artists participating in the Future Front space, should apply individually as Artists listing Future Front as their venue; OR, if you’re organizing a group exhibition at a friend’s home with multiple artists; the exhibit should have a name, a website or social media account, that represents the whole group or project.</p>
        <br />
        <br />
        <p>None of the above? <a href="mailto:trevino@bigmedium.org">Contact us</a> to see if becoming a Creative and Business Partner is the right choice for you.</p>

        <div class="submit">
          <button class="btn" @click="prevStep">Back</button>
          <button :class="'btn' + (loading ? ' loading' : '')" @click="nextStep" :disabled="!step1Valid">Save and Continue</button>
        </div>
      </section>

      <section class="card" v-if="step === 2">
        <template v-if="submission.type !== 'Dedicated Art Space'">
          <div class="field">
            <div class="input">
              <label class="input-label">Artist First Name</label>
              <input type="text" v-model="submission.artist_first_name" class="input-field">
            </div>
          </div>
          <div class="field">
            <div class="input">
              <label class="input-label">Artist Last Name</label>
              <input type="text" v-model="submission.artist_last_name" class="input-field">
            </div>
          </div>
          <div class="field">
            <div class="input">
              <label class="input-label">Collaborative Name</label>
              <input type="text" v-model="submission.collaborative_name" class="input-field">
            </div>
            <p>ONLY for artists actively creating work together under one name. If this applies to you please leave the first and last name fields blank.</p>
          </div>
        </template>

        <div class="field" v-if="submission.type === 'Dedicated Art Space' || submission.type === 'Temporary Art Experience'">
          <div class="input">
            <label class="input-label">Art Galleries, Museums, Nonprofits, etc. Name<span class="required">*</span></label>
            <input type="text" v-model="submission.dedicated_name" class="input-field">
          </div>
        </div>

        <div class="field">
          <div class="input">
            <label class="input-label">Contact Email<span class="required">*</span></label>
            <input type="email" inputmode="url" autocomplete="email" v-model="submission.contact_email" class="input-field">
          </div>
        </div>

        <div class="field textarea" v-if="submission.type.indexOf('If none') > -1">
          <label class="input-label">Austin Studio Tour Proposal<span class="required">*</span></label>
          <textarea v-model="submission.proposal"></textarea>
          <p>If your practice doesn't seem to fit in the previous categories, please describe your proposed project and we'll contact you directly after the open call deadline.</p>
        </div>

        <div class="submit">
          <button class="btn" @click="prevStep">Back</button>
          <button :class="'btn' + (loading ? ' loading' : '')" @click="nextStep" :disabled="!step2Valid">Save and Continue</button>
        </div>
      </section>

      <section class="card" v-if="step === 3">
        <h2>Contact</h2>
        <p>This information will be listed in the catalog and online. If you don't wish to publicize certain information, please leave that field blank.</p>

        <div class="field">
          <div class="input">
            <label class="input-label" for="phone">Phone</label>
            <input type="tel" inputmode="url" id="phone" autocomplete="tel" @input="formatPhone" v-model="submission.phone" class="input-field">
          </div>
          <p>(xxx) xxx-xxxx</p>
        </div>

        <div class="field">
          <div class="input">
            <label class="input-label">Email</label>
            <input type="email" inputmode="url" autocomplete="email" v-model="submission.email" class="input-field">
          </div>
        </div>

        <div class="field">
          <div class="input">
            <label class="input-label">Website</label>
            <input type="text" v-model="submission.website" class="input-field">
          </div>
          <p>xyz.com</p>
        </div>

        <div class="field">
          <h2>Social Media</h2>
          <p>At least one social platform is required</p>
        </div>

        <div class="field">
          <div class="input">
            <label class="input-label">Instagram (@___)</label>
            <input type="text" v-model="submission.instagram" class="input-field">
          </div>
          <p>Instagram links will be listed on the catalog and website</p>
        </div>

        <div class="field">
          <div class="input">
            <label class="input-label">Facebook (facebook.com/___)</label>
            <input type="text" v-model="submission.facebook" class="input-field">
          </div>
          <p>Facebook links will be listed on the catalog and website</p>
        </div>

        <div class="field">
          <div class="input">
            <label class="input-label">Twitter (@___)</label>
            <input type="text" v-model="submission.twitter" class="input-field">
          </div>
          <p>Twitter links will be listed on the catalog and website</p>
        </div>

        <div class="field">
          <div class="input">
            <label class="input-label">Other Online Platform</label>
            <input type="text" v-model="submission.other_platform" class="input-field">
          </div>
          <p>YouTube Channel, TikTock, Vimeo, etc.</p>
        </div>

        <div class="field textarea">
          <label v-if="submission.type === 'Temporary Art Experience'" class="input-label">Exhibition or Experience Statement<span class="required">*</span></label>
          <label v-else-if="submission.type === 'Dedicated Art Space'" class="input-label">About<span class="required">*</span></label>
          <label v-else class="input-label">Bio<span class="required">*</span></label>

          <textarea v-model="submission.bio"></textarea>
          <p :class="`char-limit${submission.bio.match(/\b\S+\b/g) && submission.bio.match(/\b\S+\b/g).length > 200 ? ' error' : ''}`">{{ submission.bio.match(/\b\S+\b/g) ? submission.bio.match(/\b\S+\b/g).length : 0 }} / 200</p>
          <p>Please provide a brief bio. Keep in mind you may provide more information in your artist statement. This information will not be included in the catalog, only online. Limit to 200 words</p>
        </div>

        <div class="field textarea">
          <label class="input-label">If you would like to include a translation, please include it here</label>
          <textarea v-model="submission.bio_translation"></textarea>
          <p>Fill out if you are plurilingual. *Keep in mind that Big Medium will not proof or correct this content.</p>
        </div>

        <div class="field other">
          <label v-if="submission.type === 'Dedicated Art Space'" class="input-label">Storefront</label>
          <label v-else class="input-label">Headshot</label>
          <br />
          <p>Image must be a minimum of 1000x1000 pixels. Acceptable file types: .jpg, .jpeg, .gif<br>This image is in addition to the images of your art and studio to help our audience engage with you, and connect you to your work. Organizations and collectives may add a group photo.</p>

          <input v-if="!submission.headshot" type="file" class="input-file" accept=".jpg,.jpeg,.gif" @change="prepareUploadFile($event, 'headshot')">
          <div v-else class="file-info">
            <a :href="submission.headshot.url" target="_blank">{{ submission.headshot.url }}</a>
            <button class="delete" @click="deleteFile($event, 'headshot')">Delete</button>
          </div>
        </div>

        <div class="submit">
          <button class="btn" @click="prevStep">Back</button>
          <button :class="'btn' + (loading ? ' loading' : '')" @click="nextStep" :disabled="!step3Valid">Save and Continue</button>
        </div>
      </section>

      <section class="card" v-if="step === 4">
        <h2>Participating Artists and Exhibition or Experience Description</h2>
        <p>While we've set no word limit, keep in mind audiences will not read statements that are excessively long. Successful statements are concise, coherent, and clear.</p>

        <div class="field textarea">
          <label v-if="submission.type === 'Temporary Art Experience'" class="input-label">Participating Artists and Exhibition or Experience Description<span class="required">*</span></label>
          <label v-else-if="submission.type === 'Dedicated Art Space'" class="input-label">Exhibition Description and Participating Artist(s)<span class="required">*</span></label>
          <label v-else class="input-label">Artist Statement<span class="required">*</span></label>

          <textarea v-model="submission.artist_statement"></textarea>
          <p>This information will not be included in the catalog, only online.</p>
        </div>

        <div class="field textarea">
          <label class="input-label">If you would like to include a translation, please include it here</label>
          <textarea v-model="submission.artist_statement_translation"></textarea>
          <p>Fill out if you are plurilingual. *Keep in mind that Big Medium will not proof or correct this content.</p>
        </div>

        <div class="field other" v-if="schema">
          <label class="input-label">How would you classify your practice?<span class="required">*</span></label>
          <div class="input-radio">
            <label v-for="option in schema.practice.enum" :key="option">
              <input type="radio" :value="option" v-model="submission.practice">
              <span>{{ option }}</span>
            </label>
          </div>
          <p>Pick the category you most identify with.</p>
        </div>

        <div v-if="submission.type !== 'Dedicated Art Space'" class="field">
          <div class="input">
            <label class="input-label">Medium<span class="required">*</span></label>
            <input type="text" v-model="submission.medium" class="input-field">
          </div>
          <p>This is meant to be a 1-2 word overview of how you classify yourself as an artist i.e. Multidisciplinary, sculptor, painter, ceramicist, film maker, performance artist/space<br><br>Please do not list materials here, you will have the opportunity to list all media for each artwork below.</p>
        </div>

        <div v-if="submission.type !== 'Dedicated Art Space'" class="field">
          <div class="input">
            <label class="input-label">Venue Name</label>
            <input type="text" v-model="submission.venue" class="input-field">
          </div>
          <p>Only if applicable. If participating in a temporary space, please request from your hosts the official name, address and ADA specifications to be consistent with your studio mates.</p>
        </div>

        <div class="field">
          <div class="input">
            <label class="input-label">How many tours have you participated in?<span class="required">*</span></label>
            <input type="number" v-model="submission.tour_count" class="input-field">
          </div>
        </div>

        <div class="field other" v-if="schema">
          <label class="input-label">Is your exhibiting address on the WEST or EAST of IH35?<span class="required">*</span></label>
          <div class="input-radio">
            <label v-for="option in schema.tour_side.enum" :key="option">
              <input type="radio" :value="option" v-model="submission.tour_side">
              <span>{{ option }}</span>
            </label>
          </div>
        </div>

        <div class="field">
          <label>Location that will be on the tour</label>
          <div class="input">
            <label class="input-label">Address 1<span class="required">*</span></label>
            <input type="text" autocomplete="street-address" v-model="submission.tour_address" class="input-field">
          </div>
          <p>Please abbreviate any instance of Street, Lane, Road, etc. to St, Ln, Rd (with no period)<br><br>i.e. 916 Springdale Rd</p>
        </div>

        <div class="field">
          <div class="input">
            <label class="input-label">Address 2</label>
            <input type="text" autocomplete="" v-model="submission.tour_address_2" class="input-field">
          </div>
          <p>i.e. Bldg 2, #101</p>
        </div>

        <div class="field">
          <div class="input">
            <label class="input-label">City<span class="required">*</span></label>
            <input type="text" autocomplete="address-level2" v-model="submission.tour_city" class="input-field">
          </div>
        </div>

        <div class="field other" v-if="schema">
          <label class="input-label">State<span class="required">*</span></label>
          <select v-model="submission.tour_state">
            <option v-for="option in schema.tour_state.items.enum" :key="option" :value="option">{{ option }}</option>
          </select>
        </div>

        <div class="field">
          <div class="input">
            <label class="input-label">Zipcode<span class="required">*</span></label>
            <input type="number" autocomplete="postal-code" v-model="submission.tour_zip" class="input-field">
          </div>
        </div>

        <div class="field">
          <p>This location will be shown on the website, app, and printed catalog. If the pin is not in the correct spot, click anywhere on the map to set your own position.</p>
        </div>

        <GmapMap
          ref="mapRef"
          @click="mapClick"
          :center="submission.coordinates && submission.coordinates.includes(',') ? { lat: +submission.coordinates.split(',')[0], lng: +submission.coordinates.split(',')[1] } : { lat: 30.275, lng: -97.745 }"
          :options="{
            disableDefaultUI: true,
            streetViewControl: false,
            fullscreenControl: false,
            clickableIcons: false,
            zoom: submission.coordinates ? 16 : 12.5,
          }"
        >
          <gmap-marker
            v-if="submission.coordinates && submission.coordinates.includes(',')"
            :position="{ lat: +submission.coordinates.split(',')[0], lng: +submission.coordinates.split(',')[1] }"
            :icon="mapIcon"
          ></gmap-marker>
        </GmapMap>
        <button v-if="didUseMap" :class="'btn'" @click="resetMap">Reset</button>

        <div class="submit">
          <button class="btn" @click="prevStep">Back</button>
          <button :class="'btn' + (loading ? ' loading' : '')" @click="nextStep" :disabled="!step4Valid">Save and Continue</button>
        </div>
      </section>

      <section class="card" v-if="step === 5">
        <h2>Accessibility</h2>
        <p>Please take a moment to determine your space's accessibility by using the following checklist. Please click <a href="https://www.tdlr.texas.gov/ab/abtas.htm" target="_blank">here</a> for details on official State of Texas ADA requirements. If you're a guest in a space, your host will provide you with the official answers, please submit them accordingly.</p>

        <div class="field other" v-if="schema">
          <label class="input-label">Parking<span class="required">*</span></label>
          <div class="input-radio">
            <label v-for="option in schema.a11y_parking.items.enum" :key="option">
              <input type="checkbox" :value="option" v-model="submission.a11y_parking">
              <span>{{ option }}</span>
            </label>
          </div>
        </div>

        <div class="field other" v-if="schema">
          <label class="input-label">Entrance &amp; Interior Mobility<span class="required">*</span></label>
          <div class="input-radio">
            <label v-for="option in schema.a11y_mobility.items.enum" :key="option">
              <input type="checkbox" :value="option" v-model="submission.a11y_mobility">
              <span>{{ option }}</span>
            </label>
          </div>
        </div>

        <div class="field other" v-if="schema">
          <label class="input-label">Restrooms<span class="required">*</span></label>
          <div class="input-radio">
            <label v-for="option in schema.a11y_restrooms.items.enum" :key="option">
              <input type="checkbox" :value="option" v-model="submission.a11y_restrooms">
              <span>{{ option }}</span>
            </label>
          </div>
        </div>

        <div class="field other" v-if="schema">
          <label class="input-label">Other<span class="required">*</span></label>
          <div class="input-radio">
            <label v-for="option in schema.a11y_other.items.enum" :key="option">
              <input type="checkbox" :value="option" v-model="submission.a11y_other">
              <span>{{ option }}</span>
            </label>
          </div>
        </div>

        <div class="field other" v-if="schema">
          <label class="input-label">Is your content family friendly?<span class="required">*</span></label>
          <div class="input-radio">
            <label v-for="option in schema.a11y_family.enum" :key="option">
              <input type="radio" :value="option" v-model="submission.a11y_family">
              <span>{{ option }}</span>
            </label>
          </div>
        </div>

        <div class="submit">
          <button class="btn" @click="prevStep">Back</button>
          <button :class="'btn' + (loading ? ' loading' : '')" @click="nextStep" :disabled="!step5Valid">Save and Continue</button>
        </div>
      </section>

      <template v-if="step === 6">
        <template v-for="(art, index) in submission.artwork">
          <section class="card" v-if="currentArtwork == index || index == null" :key="index">
            <h2>Add Artwork {{ index + 1 }}</h2>
            <p>Please submit six images for consideration that best represent your art. One of your images will be featured in the catalog, and all six on the desktop and mobile website. Big Medium has final selection on catalog images. Please submit your images in order of your personal preference, with the image you'd like to see printed in the catalog first.</p>
            <p>Please use the following guidelines when uploading artwork:</p>
            <br />
            <ul>
              <li>Images must be a JPG (quality set to maximum)</li>
              <li>Images should be 300dpi for print</li>
              <li>Images must be at least 5” or 1500 pixels wide</li>
            </ul>
            <p>Images should be representative of the art to be experienced during the tour.</p>
            <div class="field other">
              <label>Image<span class="required">*</span></label>
              <input v-if="!art.images[0].image" type="file" @change="prepareUploadFile($event, 'artwork', 0)" class="input-file" accept=".jpg,.jpeg">
              <div v-else class="file-info">
                <a :href="art.images[0].image.url" target="_blank">{{ art.images[0].image.url }}</a>
                <button class="delete" @click="deleteFile($event, 'artwork', 0)">Delete</button>
              </div>
            </div>
            <div class="field">
              <div class="input">
                <label class="input-label">Title<span class="required">*</span></label>
                <input type="text" v-model="art.title" class="input-field" placeholder="Title, by Artist Name. i.e. Flowers by Pepe Coronado">
              </div>
            </div>
            <div class="field">
              <div class="input">
                <label class="input-label">Year<span class="required">*</span></label>
                <input type="text" v-model="art.year" class="input-field">
              </div>
            </div>
            <div class="field">
              <div class="input">
                <label class="input-label">Materials<span class="required">*</span></label>
                <input type="text" v-model="art.materials" class="input-field">
              </div>
              <p>i.e. Oil on canvas</p>
            </div>
            <div class="field">
              <div class="input">
                <label class="input-label">Height (Inches)<span class="required">*</span></label>
                <input type="text" v-model="art.height" class="input-field">
              </div>
            </div>
            <div class="field">
              <div class="input">
                <label class="input-label">Width (Inches)<span class="required">*</span></label>
                <input type="text" v-model="art.width" class="input-field">
              </div>
            </div>
            <div class="field">
              <div class="input">
                <label class="input-label">Depth</label>
                <input type="text" v-model="art.depth" class="input-field">
              </div>
              <p>Only for 3D work</p>
            </div>
            <div class="field other" v-if="schema">
              <label class="input-label">Dimension<span class="required">*</span></label>
              <div class="input-radio">
                <label v-for="option in schema.artwork.items.properties.dimension.enum" :key="option">
                  <input type="radio" :value="option" v-model="art.dimension">
                  <span>{{ option }}</span>
                </label>
              </div>
            </div>
            <div class="field other" v-if="schema && art.dimension === 'Two dimensional'">
              <label class="input-label">Orientation<span class="required">*</span></label>
              <div class="input-radio">
                <label v-for="option in schema.artwork.items.properties.orientation.enum" :key="option">
                  <input type="radio" :value="option" v-model="art.orientation">
                  <span>{{ option }}</span>
                </label>
              </div>
            </div>
            <div class="field">
              <div class="input">
                <label class="input-label">Price<span class="required">*</span></label>
                <input type="text" v-model="art.price" class="input-field">
              </div>
              <p>List NFS if not for sale.</p>
            </div>
            <div class="field other" v-if="schema">
              <label class="input-label">Mediums<span class="required">*</span></label>
              <div class="input-radio grid">
                <label v-for="option in schema.artwork.items.properties.mediums.items.enum" :key="option">
                  <input type="checkbox" :value="option" v-model="art.mediums">
                  <span>{{ option }}</span>
                </label>
              </div>
              <p>For search functionality, please only select primary mediums for each work and err on the side of modesty. <br><br>i.e. A painting on panel should not include wood as a medium. </p>
            </div>
            <div class="field other" v-if="schema">
              <label class="input-label">Subject<span class="required">*</span></label>
              <div class="input-radio grid">
                <label v-for="option in schema.artwork.items.properties.subject.items.enum" :key="option">
                  <input type="checkbox" :value="option" v-model="art.subject">
                  <span>{{ option }}</span>
                </label>
              </div>
              <p>For search functionality. Please only select primary subjects for each work and err on the side of modesty. <br><br>i.e. If a painting includes distant people in a landscape setting, that work should not necessarily be categorized under people.</p>
            </div>
            <div class="field other" v-if="schema">
              <label class="input-label">Palette<span class="required">*</span></label>
              <div class="input-radio grid">
                <label v-for="option in schema.artwork.items.properties.palette.items.enum" :key="option">
                  <input type="checkbox" :value="option" v-model="art.palette">
                  <span>{{ option }}</span>
                </label>
              </div>
              <p>For search functionality. Please only select primary palettes for each work and err on the side of modesty. <br><br>i.e. A primarily bright work with some dark hues should not necessarily include a dark hues tag.</p>
            </div>

            <div class="submit">
              <button class="btn" @click="prevStep">Back</button>
              <button class="btn" @click="prevArtwork" v-if="currentArtwork > 0">Previous Artwork</button>
              <button class="btn" @click="addArtwork" :disabled="!step6Valid" v-if="currentArtwork < 5">Add Another</button>
              <button :class="'btn' + (loading ? ' loading' : '')" @click="nextStep" :disabled="!step6Valid">Finished with Artwork</button>
            </div>
          </section>
        </template>
      </template>

      <section class="card" v-if="step === 7">
        <h2 v-if="submission.type === 'Dedicated Art Space'">Events or space images for promotion</h2>
        <h2 v-else>Studio Images</h2>
        <p>Provide up to 6 images of your studio space, works in progress, tools, or other process documentation. These images may be used for promotion.</p>
        <p>Please use the following guidelines when uploading artwork:</p>
        <br />
        <ul>
          <li>Images must be a JPG (quality set to maximum)</li>
          <li>Images should be 300dpi for print</li>
          <li>Images must be at least 5” or 1500 pixels wide</li>
        </ul>

        <div class="field other" v-for="(image, index) in submission.studio_images" :key="index">
          <label>Image {{ +(index) + 1 }}<span class="required" v-if="index == 0">*</span></label>
          <input v-if="!image.image" type="file" @change="prepareUploadFile($event, 'studio', index)" class="input-file" accept=".jpg,.jpeg">
          <div v-else class="file-info">
            <a :href="image.image.url" target="_blank">{{ image.image.url }}</a>
            <button v-if="image.image" class="delete" @click="deleteFile($event, 'studio', index)">Delete</button>
          </div>
        </div>

        <div class="submit">
          <button class="btn" @click="prevStep">Back</button>
          <button :class="'btn' + (loading ? ' loading' : '')" @click="nextStep" :disabled="!step7Valid">Save and Continue</button>
        </div>
      </section>

      <section class="card" v-if="step === 8">
        <h2>Fellowship</h2>
        <p>Big Medium awards artists Fellowships based on artistic merit and financial limitations. Austin Studio Tour applicants may apply for a Fellowship to receive partial or full financial support to cover the participation fee. Full, and half Fellowships are available.</p>

        <div class="field other" v-if="schema">
          <label class="input-label">Would you like to apply for a fellowship?</label>
          <div class="input-radio">
            <label v-for="option in schema.fellowship.enum" :key="option">
              <input type="radio" :value="option" v-model="submission.fellowship">
              <span>{{ option }}</span>
            </label>
          </div>
        </div>
        <template v-if="submission.fellowship === 'Yes'">
          <div class="field textarea">
            <label class="input-label">Briefly describe your dedication to your artistic practice.<span class="required">*</span></label>
            <textarea v-model="submission.fellowship_dedication"></textarea>
          </div>
          <div class="field textarea">
            <label class="input-label">Describe the reason for applying for a fellowship<span class="required">*</span></label>
            <textarea v-model="submission.fellowship_reason"></textarea>
            <p>Limit 100 words</p>
          </div>
        </template>

        <div class="submit">
          <button class="btn" @click="prevStep">Back</button>
          <button :class="'btn' + (loading ? ' loading' : '')" @click="nextStep" :disabled="!step8Valid">Save and Continue</button>
        </div>
      </section>

      <section class="card" v-if="step === 9">
        <h2>Demographic Information</h2>
        <p>This information will be used for grant reporting and to identify future funding opportunities for Big Medium only. It will not be used to score your application.</p>
        <p v-if="submission.type === 'Dedicated Art Space'">This information should apply to the main contact.</p>

        <div class="field">
          <div class="input">
            <label class="input-label">What is your date of birth? (mm/dd/yyyy)</label>
            <input type="date" v-model="submission.birth_date" class="input-field">
          </div>
        </div>

        <div class="field other" v-if="schema">
          <label class="input-label">How do you identify your gender?<span class="required">*</span></label>
          <div class="input-radio">
            <label v-for="option in schema.gender.enum" :key="option">
              <input type="radio" :value="option" v-model="submission.gender">
              <span>{{ option }}</span>
            </label>
          </div>
        </div>

        <div class="field other" v-if="schema">
          <label class="input-label">How do you identify your race?<span class="required">*</span></label>
          <div class="input-radio">
            <label v-for="option in schema.race.items.enum" :key="option">
              <input type="checkbox" :value="option" v-model="submission.race">
              <span>{{ option }}</span>
            </label>
          </div>
        </div>

        <div class="field" v-if="submission.race.indexOf('Other') > -1">
          <div class="input">
            <label class="input-label">Other<span class="required">*</span></label>
            <input type="text" v-model="submission.race_other" class="input-field">
          </div>
        </div>

        <div class="field other" v-if="schema">
          <label class="input-label">Do you identify with any of the following groups? Select all that apply.</label>
          <div class="input-radio">
            <label v-for="option in schema.groups.items.enum" :key="option">
              <input type="checkbox" :value="option" v-model="submission.groups">
              <span>{{ option }}</span>
            </label>
          </div>
        </div>

        <h2>Additional Information</h2>
        <p>This information will be used to identify future funding opportunities for Big Medium. It will not be used to score your application.</p>

        <div class="field other" v-if="schema">
          <label class="input-label">Did you attend or <strong>are affiliated (i.e. student, alumni, faculty, staff, etc.)</strong> with any of the following local colleges/universities? Select all that apply.</label>
          <div class="input-radio">
            <label v-for="option in schema.attendance.items.enum" :key="option">
              <input type="checkbox" :value="option" v-model="submission.attendance">
              <span>{{ option }}</span>
            </label>
          </div>
        </div>

        <div class="submit">
          <button class="btn" @click="prevStep">Back</button>
          <button :class="'btn' + (loading ? ' loading' : '')" @click="nextStep" :disabled="!step9Valid">Save and Continue</button>
        </div>
      </section>

      <section class="card" v-if="step === 10 && submission.paid">
        <h2>Complete</h2>
        <p>You have already submitted this application and edits have been saved. You may now close this window.</p>

        <div class="submit">
          <button class="btn" @click="prevStep">Back</button>
          <a class="btn" :href="`/#/participants/${userID}?preview=true`" target="_blank">Preview your listing</a>
        </div>
      </section>

      <section class="card" v-else-if="step === 10">
        <h2>Extras</h2>
        <p>Your fee includes 1 catalog and 1 sign. If you would like extra items, you may purchase catalogs at $20 each and signs at $12 each. Please identify how many of each item you would like to purchase below:</p>

        <div class="field">
          <div class="input">
            <label class="input-label">Catalogs</label>
            <input type="number" min="0" v-model="submission.catalogs" class="input-field">
          </div>
        </div>

        <div class="field">
          <div class="input">
            <label class="input-label">Signs</label>
            <input type="number" min="0" v-model="submission.signs" class="input-field">
          </div>
        </div>

        <div class="submit">
          <button class="btn" @click="prevStep">Back</button>
          <button :class="'btn' + (loading ? ' loading' : '')" @click="nextStep">Save and Continue</button>
        </div>
      </section>

      <section class="card final" v-if="step === 11">
        <h2>Your total is ${{ submission.total }}</h2>

        <table>
          <thead>
            <tr>
              <th>Item</th>
              <th>Quantity</th>
              <th>Unit price</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Submission fee</td>
              <td>1</td>
              <td>${{ submission.submission_fee }}</td>
              <td>${{ submission.submission_fee * 1 }}</td>
            </tr>
            <tr>
              <td>Catalog</td>
              <td>{{ submission.catalogs || 0 }}</td>
              <td>$20</td>
              <td>${{ submission.catalogs * 20 }}</td>
            </tr>
            <tr>
              <td>Sign</td>
              <td>{{ submission.signs || 0 }}</td>
              <td>$12</td>
              <td>${{ submission.signs * 12 }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th></th>
              <th></th>
              <th></th>
              <th><strong>${{ submission.total }}</strong></th>
            </tr>
          </tfoot>
        </table>

        <div class="input-radio">
          <label>
            <input type="checkbox" value="yes" v-model="submission.cover_fees" @click="coverFees">
            <span for="yes">Add 3% to your total to help us cover processing fees.</span>
          </label>
        </div>

        <div class="field">
          <div class="input">
            <label class="input-label">Promo code</label>
            <input type="text" v-model="submission.promo" class="input-field">
          </div>
          <p>Have a promo code?</p>
        </div>
        <button :class="'btn' + (promoLoading ? ' loading' : '')" @click="verifyPromo">Verify</button>

        <div class="submit">
          <button class="btn" @click="prevStep">Back</button>
          <a class="btn" :href="`/#/participants/${userID}?preview=true`" target="_blank">Preview your listing</a>
          <form v-if="submission.total > 0" :action="$root.api_url + 'checkout?userType=' + type + '&id=' + userID + '&total=' + submission.total" method="POST">
            <button :class="'btn' + (loading ? ' loading' : '')">Proceed to Checkout</button>
          </form>
          <button v-else :class="'btn' + (loading ? ' loading' : '')" @click="finish">Finish</button>
        </div>
      </section>

      <section class="card final" v-if="step === 'finish'">
        <h2>Thank you! Your submission has been received.</h2>
        <p>You may now close this window.</p>
        <div class="submit">
          <a class="btn" :href="`/#/participants/${userID}?preview=true`" target="_blank">View your listing</a>
        </div>
      </section>
      <section class="card" v-if="step === 'checkout_verify'">
        <h2>Verifying payment...</h2>
      </section>
      <section class="card" v-if="step === 'checkout_success'">
        <h2>Thank you! Payment has been received.</h2>
        <p>You may now close this window.</p>
        <div class="submit">
          <a class="btn" :href="`/#/participants/${userID}?preview=true`" target="_blank">View your listing</a>
        </div>
      </section>
      <section class="card" v-if="step === 'checkout_error'">
        <h2>There was an error processing payment</h2>
        <p>Click the link below to restart.</p>
        <button class="btn" @click="reset">Try Again</button>
      </section>

      <footer v-if="submission && !submission.paid">
        <p v-if="step > 0">Step <span>{{ step }}</span> of <span>{{ totalSteps }}</span></p>
      </footer>
    </div>
  </div>
</template>

<script>
import Forms from "./Forms";

export default {
  name: 'participants',
  components: {},
  mixins: [Forms],
  data() {
    return {
      totalSteps: 11,
      currentArtwork: 0,
      step0Valid: false,
      step1Valid: false,
      step2Valid: false,
      step3Valid: false,
      step4Valid: false,
      step5Valid: false,
      step6Valid: false,
      step7Valid: false,
      step8Valid: false,
      phone: '',
    };
  },
  mounted() {
    if (this.$route.query.checkout_success) {
      this.step = 'checkout_verify';
      this.verifyCheckoutSuccess();
    } else if (this.$route.query.checkout_cancel) {
      this.step = 'loading';
      this.login(null, 11);
    } else {
      if (localStorage.getItem('userID')) {
        this.step = 'loading';
        this.login();
      }
    }
  },
  methods: {
    prevArtwork() {
      this.currentArtwork--;
      this.validate();
      window.scrollTo(0, 0);
    },
    async addArtwork() {
      // Add new artwork object if it does not already exist
      if (!this.submission.artwork[this.currentArtwork + 1]) {
        this.submission.artwork.push({
          show_in_catalog: false,
          id: this.currentArtwork + 1,
          images: [
            {image: null},
            {image: null},
            {image: null},
          ],
          title: '',
          year: '',
          materials: '',
          height: '',
          width: '',
          depth: '',
          dimension: '',
          orientation: '',
          price: '',
          mediums: [],
          subject: [],
          palette: [],
        });
      }

      await this.syncUser();
      this.currentArtwork++;
      this.validate();
      window.scrollTo(0, 0);
    },

    formatPhone() {
      let phoneNumber = this.submission.phone.replace(/\D/g, '');
      if (phoneNumber.length > 10) {
        phoneNumber = phoneNumber.slice(0, 10);
      }
      let formattedNumber = phoneNumber.replace(/(\d{3})(\d{0,3})(\d{0,4})/, '($1) $2-$3');
      this.submission.phone = formattedNumber;
    },

    validate() {
      // Step 0
      this.step0Valid = false;
      if (this.submission.space_acknowledgement && this.submission.time_acknowledgement) this.step0Valid = true;

      // Step 1
      this.step1Valid = false;
      if (this.submission.type.length) this.step1Valid = true;

      // Step 2
      let dedicatedConditional = true;
      if (this.submission.type === 'Dedicated Art Space' || this.submission.type === 'Temporary Art Experience') dedicatedConditional = this.submission.dedicated_name.length > 0;
      let proposalConditional = true;
      if (this.submission.type.indexOf('If none') > -1) proposalConditional = this.submission.proposal.length > 0;
      if (
        dedicatedConditional &&
        proposalConditional &&
        this.submission.contact_email.length > 0 &&
        this.submission.contact_email.indexOf('@') > -1
      ) {
        this.step2Valid = true;
      } else {
        this.step2Valid = false;
      }

      // Step 3
      if (
        this.submission.bio.length > 0 &&
        (this.submission.bio.match(/\b\S+\b/g) && this.submission.bio.match(/\b\S+\b/g).length < 201)
      ) {
        this.step3Valid = true;
      } else {
        this.step3Valid = false;
      }


      // Step 4
      if (
        this.submission.artist_statement.length > 0 &&
        this.submission.practice.length > 0 &&
        (this.submission.type !== 'Dedicated Art Space' ? this.submission.medium.length > 0 : true) &&
        this.submission.tour_address.length > 0 &&
        this.submission.tour_city.length > 0 &&
        this.submission.tour_state.length > 0 &&
        this.submission.tour_zip.length > 0 &&
        this.submission.tour_side.length > 0 &&
        this.submission.tour_count.length > 0
      ) {
        this.step4Valid = true;
      } else {
        this.step4Valid = false;
      }

      // Step 5
      if (
        this.submission.a11y_parking.length > 0 &&
        this.submission.a11y_mobility.length > 0 &&
        this.submission.a11y_restrooms.length > 0 &&
        this.submission.a11y_other.length > 0 &&
        this.submission.a11y_family.length > 0
      ) {
        this.step5Valid = true;
      } else {
        this.step5Valid = false;
      }

      // Step 6
      if (
        this.submission.artwork[this.currentArtwork].images[0].image &&
        this.submission.artwork[this.currentArtwork].title.length > 0 &&
        this.submission.artwork[this.currentArtwork].year.length > 0 &&
        this.submission.artwork[this.currentArtwork].materials.length > 0 &&
        this.submission.artwork[this.currentArtwork].width.length > 0 &&
        this.submission.artwork[this.currentArtwork].height.length > 0 &&
        this.submission.artwork[this.currentArtwork].dimension.length > 0 &&
        this.submission.artwork[this.currentArtwork].price.length > 0 &&
        (this.submission.type !== 'Dedicated Art Space' ? this.submission.artwork[this.currentArtwork].mediums.length > 0 : true) &&
        this.submission.artwork[this.currentArtwork].subject.length > 0 &&
        this.submission.artwork[this.currentArtwork].palette.length > 0
      ) {
        this.step5Valid = true;

        if (this.submission.artwork[this.currentArtwork].dimension === 'Two dimensional') {
          if (this.submission.artwork[this.currentArtwork].orientation.length > 0) {
            this.step6Valid = true;
          } else {
            this.step6Valid = false;
          }
        } else if (this.submission.artwork[this.currentArtwork].dimension === 'Three dimensional') {
          if (this.submission.artwork[this.currentArtwork].orientation.length >= 0) {
            this.step6Valid = true;
          }
        }
        else if (this.submission.artwork[this.currentArtwork].dimension === 'Time based') {
          this.step6Valid = true;
        }
      } else {
        this.step6Valid = false;
      }

      // Step 7
      if (this.submission.studio_images[0].image) {
        this.step7Valid = true;
      } else {
        this.step7Valid = false;
      }

      // Step 8
      if (
        this.submission.fellowship === 'No' || this.submission.fellowship_dedication.length > 0 && this.submission.fellowship_reason.length > 0
      ) {
        this.step8Valid = true;
      } else {
        this.step8Valid = false;
      }

      // Step 9
      if (
        this.submission.gender.length > 0 &&
        this.submission.race.length > 0 &&
        (this.submission.race.indexOf('Other') > -1 ? this.submission.race_other.length > 0 : true)
      ) {
        this.step9Valid = true;
      } else {
        this.step9Valid = false;
      }
    },

    reset() {
      location.href = `/#/participate`;
      location.reload();
    },
  },
  // mounted() {
  //   if (moment().isAfter('2022-09-06 23:59')) {
  //     location.href = 'https://www.bigmedium.org/austinstudiotour';
  //   } else {
  //     console.log(`Form is active because date is before 2022-09-06 23:59 ${moment().isBefore('2022-09-06 23:59')}`)
  //   }
  // }
};
</script>

<style scoped lang="less">
  html, body {
    width: auto;
    height: auto;
    overflow: initial;
    -webkit-user-select: initial;
    background-color: #F7F6F3;
  }
</style>
<style src="./Forms.less" lang="less" scoped></style>



// WEBPACK FOOTER //
// src/pages/Forms/AST.vue